import type { Project } from "../types";

export const projectsEn: Project[] = [
  {
    "id": "seger-fuar-tanitim-filmi",
    "slug": "seger-fuar-tanitim-filmi",
    "title": "Seger - \"Adımızı Bilmezsiniz Ama Sesimizi Bilirsiniz\" Yol Hikayeleri",
    "client": "SEGER Korna",
    "year": 2024,
    "shortDescription": "SEGER Korna cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Farklı coğrafyalarda, zorlu yol koşullarında ve günlük yaşamın içinde Seger'in sesine odaklanan çok bölümlü sinematik reklam serisi üretildi. Akılda kalıcı slogan ve güçlü görsel ritim oluşturuldu.",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "SEGER"
      },
      {
        "role": "Ajans",
        "name": "YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Uluç Yemen Aslan"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera Asistanı",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Ses Teknisyeni",
        "name": "Yener Yalçın"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/seger-fuar-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=wXAec6qk63M",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/seger-fuar-tanitim-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "SEGER Korna cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for SEGER Korna that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie",
    "slug": "endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie",
    "title": "Endocare Renewal Serisi - Türkiye Lansman Turu Aftermovie & Etkinlik Filmleri",
    "client": "Teka Estetik",
    "year": 2024,
    "shortDescription": "Teka Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "3 şehirde eşzamanlı gezici prodüksiyon ekibiyle hekim röportajları, ürün deneyim anları ve workshop detayları sinematik gimbal hareketleriyle kayıt altına alındı.",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Teka Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      }
    ],
    "coverImage": "/project-covers/endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=-aVKBzjCWvw",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Teka Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Teka Estetik that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "gokhan-haytoglu-vivacy-workshop",
    "slug": "gokhan-haytoglu-vivacy-workshop",
    "title": "Gökhan Haytoğlu - Vivacy Workshop",
    "client": "TEKA Estetik",
    "year": 2023,
    "shortDescription": "TEKA Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri TEKA Estetik Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Harutyun Arto Davulciyan, Enes Aktel Kurgu Bora Selimoğlu\n\nGökhan Haytoğlu: Kusursuz Güzellik İçin Estetik Bakış Açısı\n\nEstetik cerrahinin öncü ismi Dr. Gökhan Haytoğlu, kusursuz bir eğitim geçmişi ve uluslararası deneyimleriyle öne çıkıyor. Hatay doğumlu olan Dr. Haytoğlu, uzmanlık alanı olan plastik, rekonstrüktif ve estetik cerrahide başarılarını kanıtlamıştır. Ulusal ve uluslararası düzeyde yayınlanan makaleleri ve sunumlarıyla bilimsel katkıda bulunan Dr. Haytoğlu, sürekli olarak sektördeki yenilikleri takip ederek mükemmeliyeti hedeflemektedir\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TEKA Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Harutyun Arto Davulciyan, Enes Aktel"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/gokhan-haytoglu-vivacy-workshop.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=XG8aankRMK8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/gokhan-haytoglu-vivacy-workshop/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "TEKA Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for TEKA Estetik that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "barut-fethiye-sensatori-tanitim-filmi",
    "slug": "barut-fethiye-sensatori-tanitim-filmi",
    "title": "Barut Hotels - Akdeniz'in Doğasında Lüks ve Huzurun Sinematik Portresi",
    "client": "Barut Hotels",
    "year": 2024,
    "shortDescription": "Barut Hotels cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Gündoğumu ve günbatımının sihirli saatlerinde çekilen sinematik hava ve kara planları, SPA ve gurme lezzetlerin makro dokunuşlarıyla zenginleştirildi.",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Barut Hotels"
      },
      {
        "role": "Ajans",
        "name": "Pozitif Film"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Fatih Uzgören"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Baret Borucuyan, Edvin Büyükloker"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/barut-fethiye-sensatori-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=DhpnzoSCbms",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/barut-fethiye-sensatori-tanitim-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 4 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Barut Hotels cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Barut Hotels that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "pinar-protein-kurumsal-marka-proje-sunumu",
    "slug": "pinar-protein-kurumsal-marka-proje-sunumu",
    "title": "Pınar Protein - Kurumsal Marka & Proje Sunumu",
    "client": "Pınar Protein",
    "year": 2023,
    "shortDescription": "Pınar Protein cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri Pınar Protein Ajans Levent Kuğu Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nKurgu Harutyun Arto Davulciyan\n\nPınar Süt, 1973 yılında kurulan ve Türkiye’nin önde gelen markalarından biridir. Geniş ürün yelpazesiyle peynir, yoğurt, süt tozu ve daha fazlasını üreten Pınar, sağlıklı yaşamın önemini vurgulayan Pınar Protein ürünleriyle dikkat çekiyor. Besleyici ve protein açısından zengin ürünleriyle bilinen Pınar, lezzet ve kaliteyi bir araya getirerek tüketicilerine sağlıklı bir yaşam tarzı sunuyor.\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Pınar Protein"
      },
      {
        "role": "Ajans",
        "name": "Levent Kuğu"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Kurgu",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/pinar-protein-kurumsal-marka-proje-sunumu.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=6IC4x3jeCPo",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/pinar-protein-kurumsal-marka-proje-sunumu/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Pınar Protein cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Pınar Protein that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "kristal-piksel-2024-web-sitesi",
    "slug": "kristal-piksel-2024-web-sitesi",
    "title": "Kristal Piksel 2024 - Web Sitesi",
    "client": "TOGED",
    "year": 2024,
    "shortDescription": "TOGED cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Türkiye’de geliştirilen özgün fikrî mülkiyete sahip oyunları belirleme ve ödüllendirme amacıyla 2012 yılından beri düzenlenen ve Türkiye’nin ilk ve halen tek ödül töreni olan Kristal Piksel Video Oyun Ödülleri'nin 2024 resmi web platformu, başvuru ve jüri değerlendirme altyapısı WE24 Agency tarafından tasarlandı ve geliştirildi.",
    "categories": [
      "Canlı Yayın",
      "Web Siteleri",
      "Yazılım"
    ],
    "services": [
      "Canlı Yayın",
      "Web Siteleri",
      "Yazılım"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TOGED"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      }
    ],
    "coverImage": "/project-covers/kristal-piksel-2024-web-sitesi.webp",
    "gallery": [
      "/project-covers/kristal-piksel-2024-web-sitesi-g1.webp"
    ],
    "videoUrl": "",
    "videoProvider": null,
    "originalSourceUrl": "https://we24.com.tr/project/kristal-piksel-2024-web-sitesi/",
    "featured": false,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "TOGED cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for TOGED that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "kristal-piksel-2024-canli-yayin",
    "slug": "kristal-piksel-2024-canli-yayin",
    "title": "Kristal Piksel Video Oyun Ödülleri - Canlı Yayın & Ödül Töreni Rejisi",
    "client": "Kristal Piksel",
    "year": 2024,
    "shortDescription": "Kristal Piksel cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Sahne arkası, seyirci ve ödül kürsüsünü gören 5 kameralı reji sistemi kuruldu. Önceden hazırlanan dinamik motion grafik paketleri anlık olarak canlı yayına entegre edildi.",
    "categories": [
      "Canlı Yayın"
    ],
    "services": [
      "Canlı Yayın"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TOGED"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency & 24Creative"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency & 24Creative"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Baret Tercan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/kristal-piksel-2024-canli-yayin.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=SstAUX2mrAo",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/kristal-piksel-2024-canli-yayin/",
    "featured": false,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Kristal Piksel cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Kristal Piksel that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "24-creative-we24-agency-aerial-showreel-2018",
    "slug": "24-creative-we24-agency-aerial-showreel-2018",
    "title": "WE24 & 24Creative - Aerial Cinematography & Drone Showreel",
    "client": "WE24 Agency & 24Creative",
    "year": 2018,
    "shortDescription": "24 Creative Aerial Showreel (2018) cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Hava Görüntüleri Harutyun Arto Davulciyan Kurgu Bora Selimoğlu\n\n24Creative: Prodüksiyon ve Post Prodüksiyon Hizmetleri\n\n24Creative, 2011 yılında kurulan ve iletişimde uzmanlaşmış bir prodüksiyon ve post-prodüksiyon ajansıdır. Görsel, işitsel, tasarımsal ve sanatsal projelerin üretim ve gelişim sürecini başarılı bir şekilde yönetmektedir. Müşteri memnuniyetine odaklanarak, samimi ve profesyonel hizmet anlayışıyla ihtiyaçları karşılamayı hedefler. Tecrübeli ekip ve yüzlerce marka ile çalışarak sektörde önemli bir konuma ulaşmıştır. 24Creative, her projeye heyecan ve tecrübesiyle yaklaşarak başarıya ulaşmayı amaçlar.\n\nDijital İletişim Ajansı",
    "categories": [
      "Showreel"
    ],
    "services": [],
    "credits": [
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/24-creative-we24-agency-aerial-showreel-2018.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=6q4TUMFkpTg",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/24-creative-we24-agency-aerial-showreel-2018/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "24 Creative Aerial Showreel (2018) cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for 24 Creative Aerial Showreel (2018) that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "dr-light-sosyal-medya-teaser-filmleri",
    "slug": "dr-light-sosyal-medya-teaser-filmleri",
    "title": "Dr-Light - Sosyal Medya Teaser Filmleri",
    "client": "Dr-Light",
    "year": 2023,
    "shortDescription": "Dr-Light cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri Dr-Light Ajans WE24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Artun Sağbazar, Harutyun Arto Davulciyan, Enes Aktel Kurgu Bora Selimoğlu\n\nDr-Light: Aydınlatma Sektörü’nde Lider\n\nEstetik tasarımların, nitelikli aydınlatmayla buluştuğu marka. 1950’lerde başlayan yolculuğumuzda, yarım asrı aşan deneyimimizi günümüz teknolojileriyle birleştirerek Dr-Light® markası altında aydınlatma sektöründe özgün tasarımlar sunuyoruz. Mimari projelerden konutlara kadar geniş bir yelpazede estetik ve şık aydınlatma çözümlerimizle imza atıyoruz. Şişli Showroom’umuzda sergilediğimiz koleksiyonlarımızla, profesyonel perakendecilik anlayışıyla son kullanıcıya ulaşıyoruz. Yerli üretim kalitesini uluslararası normlarda sağlayarak, tasarım ve kaliteyi herkesin erişebileceği bir noktada buluşturuyoruz.\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Dr-Light"
      },
      {
        "role": "Ajans",
        "name": "WE24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Harutyun Arto Davulciyan, Enes Aktel"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/dr-light-sosyal-medya-teaser-filmleri.webp",
    "gallery": [
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g1.webp",
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g2.webp",
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g3.webp",
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g4.webp",
      "/project-covers/dr-light-sosyal-medya-teaser-filmleri-g5.webp"
    ],
    "videoUrl": "https://www.youtube.com/watch?v=3CoXmBylLHw",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/dr-light-sosyal-medya-teaser-filmleri/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Dr-Light cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Dr-Light that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "pinar-protein-umut-duygu-ile-training-lab",
    "slug": "pinar-protein-umut-duygu-ile-training-lab",
    "title": "Pınar Protein - Umut Duygu ile Training Lab",
    "client": "Pınar Protein",
    "year": 2023,
    "shortDescription": "Pınar Protein cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri Pınar Protein Ajans Levent Kuğu Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Levent Kuğu Kamera Levent Kuğu Post Prodüksiyon Bora Selimoğlu\n\nPınar Süt, 1973 yılında kurulan ve Türkiye’nin önde gelen markalarından biridir. Geniş ürün yelpazesiyle peynir, yoğurt, süt tozu ve daha fazlasını üreten Pınar, sağlıklı yaşamın önemini vurgulayan Pınar Protein ürünleriyle dikkat çekiyor. Besleyici ve protein açısından zengin ürünleriyle bilinen Pınar, lezzet ve kaliteyi bir araya getirerek tüketicilerine sağlıklı bir yaşam tarzı sunuyor.\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Pınar Protein"
      },
      {
        "role": "Ajans",
        "name": "Levent Kuğu"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Levent Kuğu"
      },
      {
        "role": "Kamera",
        "name": "Levent Kuğu"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/pinar-protein-umut-duygu-ile-training-lab.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=oqYo67olEuc",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/pinar-protein-umut-duygu-ile-training-lab/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Pınar Protein cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Pınar Protein that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "e-konsey-tanitim-filmi",
    "slug": "e-konsey-tanitim-filmi",
    "title": "E-Konsey - Digital Advisory Platform Commercial Film",
    "client": "E-Konsey",
    "year": 2023,
    "shortDescription": "E-Konsey cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri E-Konsey Ajans Contactplus+ Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Sanat Yönetmeni Aren Arda Kaya Yürütücü Yapımcı Fatih Uzgören Kamera Artun Sağbazar Kurgu Bora Selimoğlu Grafik Aren Arda Kaya Renk Düzenleme Harutyun Arto Davulciyan\n\nE-Konsey: Online Medikal Danışmanlık\n\nTürkiye’nin önde gelen medikal danışma platformu e-konsey, sağlık sorunlarınızı uzman doktorlarla online olarak paylaşmanızı sağlar. Tetkik raporlarınız güvenilir doktorlar tarafından ayrıntılı şekilde değerlendirilir ve size en uygun tedavi önerileri sunulur. Zamandan ve maddi açıdan tasarruf sağlayarak, kaliteli sağlık hizmetine kolayca ulaşmanızı sağlayan e-konsey, güvenli ve etkili bir danışmanlık deneyimi sunar.\n\nDijital İletişim Ajansı",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "E-Konsey"
      },
      {
        "role": "Ajans",
        "name": "Contactplus+"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Fatih Uzgören"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/e-konsey-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=iD4mOWtXQmc",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/e-konsey-tanitim-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "E-Konsey cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for E-Konsey that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "fon-bulucu-tanitim-filmi",
    "slug": "fon-bulucu-tanitim-filmi",
    "title": "Fonbulucu - Türkiye'nin Kitle Fonlama Ekosistemine İlham Veren Marka Filmi",
    "client": "Fonbulucu",
    "year": 2024,
    "shortDescription": "Fonbulucu cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Gerçek girişimcilerin ve yatırımcıların hikayelerinden esinlenen, stüdyo ve gerçek ofis sahnelerinin harmanlandığı enerjik bir görsel anlatı kurgulandı.",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "fonbulucu"
      },
      {
        "role": "Ajans",
        "name": "Contactplus+"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Fatih Uzgören"
      },
      {
        "role": "Kamera",
        "name": "Harutyun Arto Davulciyan, Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/fon-bulucu-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=ypMrPN5WpBI",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/fon-bulucu-tanitim-filmi/",
    "featured": false,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Fonbulucu cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Fonbulucu that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "launch-day-stream-mount-blade-ii-bannerlord-launch-day-stream-canli-yayin",
    "slug": "launch-day-stream-mount-blade-ii-bannerlord-launch-day-stream-canli-yayin",
    "title": "Mount & Blade II: Bannerlord - Global Launch Day Multi-Camera Live Stream & Broadcast",
    "client": "TaleWorlds Entertainment",
    "year": 2024,
    "shortDescription": "Multi-camera studio broadcast reaching 500,000+ peak concurrent viewers on global launch day with zero latency and zero dropped frames.",
    "fullDescription": "24Creative ve WE24 ortaklığıyla, özel reji masası ve yüksek bant genişlikli yedekli fiber altyapı üzerinde stüdyo ortamı kuruldu. 6 bağımsız 4K kamera açısı, anlık oyun capture sistemleri ve canlı grafik giydirmeleri ile 8 saatlik kesintisiz bir küresel lansman şovu yönetildi.",
    "categories": [
      "Canlı Yayın"
    ],
    "services": [
      "Canlı Yayın"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Talesworld"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "24Creative & WE'24 Agency"
      },
      {
        "role": "Yapımcı",
        "name": "Tuğbek Ölek"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency & 24Creative"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Baret Tercan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/launch-day-stream-mount-blade-ii-bannerlord-launch-day-stream-canli-yayin.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=6HsrI92KsMQ",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/launch-day-stream-mount-blade-ii-bannerlord-launch-day-stream-canli-yayin/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Multi-camera studio broadcast reaching 500,000+ peak concurrent viewers on global launch day with zero latency and zero dropped frames.",
    "challenge": "Delivering an uncompromised global broadcast for the worldwide release of Mount & Blade II: Bannerlord with zero error tolerance across international streaming networks.",
    "insight": "Global gaming audiences demand TV-grade broadcast pacing, synchronized real-time game captures, and flawless multi-channel streaming bridges.",
    "solution": "Co-produced with 24Creative, we engineered a dedicated broadcast control room with 6 independent 4K cameras, live game-capture rigs, and interactive motion graphics for an 8-hour continuous stream.",
    "productionCraft": "1080p 60FPS zero-drop live stream encoder pipeline, Blackmagic ATEM production switcher system, multi-camera live broadcast control, and dynamic studio lighting.",
    "metrics": [
      {
        "label": "Broadcast Quality",
        "value": "1080p 60FPS"
      },
      {
        "label": "Peak Concurrent Viewers",
        "value": "500K+"
      },
      {
        "label": "Stream Duration",
        "value": "8h Uninterrupted"
      },
      {
        "label": "Platforms",
        "value": "Twitch, YouTube, Steam"
      }
    ],
    "deliverables": [
      "Live Stream Broadcast",
      "Live Motion Graphics",
      "8-Hour Full Master",
      "YouTube VOD Packages",
      "Social Media Highlight Reels"
    ],
    "productionStandard": "1080p 60FPS"
  },
  {
    "id": "dr-light-kurumsal-tanitim-filmi",
    "slug": "dr-light-kurumsal-tanitim-filmi",
    "title": "Dr-Light - Architectural Lighting Corporate Brand Film",
    "client": "Dr-Light",
    "year": 2023,
    "shortDescription": "Cinematic corporate brand film showcasing Dr-Light's luxury architectural lighting systems and bespoke luminaire designs.",
    "fullDescription": "Client: Dr-Light | Production & Post-Production: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nCinematography: Harutyun Arto Davulciyan, Artun Sağbazar\nLead Editor: Bora Selimoğlu\n\nDr-Light: Where Architectural Lighting Meets Craftsmanship\n\nA cinematic corporate brand film capturing the elegance, precision engineering, and spatial atmosphere of Dr-Light's luxury architectural lighting installations.",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Dr-Light"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/dr-light-kurumsal-tanitim-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=8hRbpPgFXoo",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/dr-light-kurumsal-tanitim-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "A high-end corporate film reinforcing Dr-Light's prestige among top-tier architects and luxury interior designers.",
    "challenge": "Translating architectural luminaire craftsmanship and subtle ambient lighting into a rich cinematic visual aesthetic.",
    "insight": "Luxury lighting is best experienced through dynamic light-and-shadow play and architectural spatial context.",
    "solution": "Shot with high-dynamic-range cinema cameras and macro lenses to highlight brass details, warm color temperatures, and interior ambience.",
    "productionCraft": "4K High Dynamic Range cinematography, cine prime lenses, DaVinci Resolve color grading.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "4K Cinema RAW"
  },
  {
    "id": "kadir-copdemir-ile-ogle-arasi-turkcell-bip",
    "slug": "kadir-copdemir-ile-ogle-arasi-turkcell-bip",
    "title": "Kadir Çöpdemir İle Öğle Arası - Turkcell BiP",
    "client": "4Play & Turkcell BiP",
    "year": 2023,
    "shortDescription": "4Play & Turkcell BiP cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri 4Play & Turkcell BiP Ajans Yemen Film Yapım I YFY Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Artun Sağbazar, Enes Aktel Kurgu Bora Selimoğlu\n\nTurkcell BiP: Yerli Teknolojilerle Geliştirilen Güvenli İletişim Platformu\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "4Play & Turkcell BiP"
      },
      {
        "role": "Ajans",
        "name": "Yemen Film Yapım I YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Enes Aktel"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/kadir-copdemir-ile-ogle-arasi-turkcell-bip.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=CLb9dR9DIIY",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/kadir-copdemir-ile-ogle-arasi-turkcell-bip/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 2 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "4Play & Turkcell BiP cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for 4Play & Turkcell BiP that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "teka-estetik-youtube-kanal-yonetimi",
    "slug": "teka-estetik-youtube-kanal-yonetimi",
    "title": "Teka Estetik - YouTube Kanal Yönetimi",
    "client": "Teka Estetik",
    "year": 2024,
    "shortDescription": "Teka Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Teka Estetik bünyesindeki dünya markalarının (Heliocare, Endocare, VIVACY) medikal estetik ve dermatoloji alanındaki video içerik stratejisi, YouTube kanal yönetimi, video optimizasyonu, kapak tasarımları ve SEO operasyonları WE24 Agency tarafından yürütülmektedir.",
    "categories": [
      "YouTube Projeleri",
      "Sosyal Medya"
    ],
    "services": [
      "YouTube Projeleri",
      "Sosyal Medya"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Teka Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      }
    ],
    "coverImage": "/project-covers/teka-estetik-youtube-kanal-yonetimi.webp",
    "gallery": [
      "/project-covers/teka-estetik-youtube-kanal-yonetimi-g1.webp"
    ],
    "videoUrl": "",
    "videoProvider": null,
    "originalSourceUrl": "https://we24.com.tr/project/teka-estetik-youtube-kanal-yonetimi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Teka Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Teka Estetik that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "her-dakika-bir-saat-eda-baba",
    "slug": "her-dakika-bir-saat-eda-baba",
    "title": "Eda Baba - Her Dakika Bir Saat Music Video",
    "client": "Eda Baba",
    "year": 2023,
    "shortDescription": "Atmospheric and emotionally resonant music video for Turkish indie artist Eda Baba's single 'Her Dakika Bir Saat'.",
    "fullDescription": "Artist: Eda Baba | Production & Post-Production: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nLead Editor & Colorist: Bora Selimoğlu, Harutyun Arto Davulciyan\n\nEda Baba: Her Dakika Bir Saat\n\nA cinematic visual journey accompanying the gentle, melancholic vocals of Eda Baba with carefully graded natural lighting and poetic framing.",
    "categories": [
      "Video Klipler"
    ],
    "services": [
      "Video Klipler"
    ],
    "credits": [
      {
        "role": "Sanatçı",
        "name": "Eda Baba"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/her-dakika-bir-saat-eda-baba.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=QWqAzH95j-o",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/her-dakika-bir-saat-eda-baba/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 3 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "A soulful cinematic music video strengthening Eda Baba's brand identity across streaming platforms.",
    "challenge": "Capturing the poetic intimacy of the song through minimalist cinematic composition and naturalistic lighting.",
    "insight": "Authentic, character-driven close-up cinematography enhances viewer resonance for acoustic musical narratives.",
    "solution": "Filmed in 4K with prime cine lenses, focused on emotive portraits and soft cinematic color science.",
    "productionCraft": "4K 24FPS cinema cameras, vintage prime glass, DaVinci Resolve color grading.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "Cinematic 4K"
  },
  {
    "id": "turkiye-futbol-vakfi-odul-toreni-trailer",
    "slug": "turkiye-futbol-vakfi-odul-toreni-trailer",
    "title": "Turkish Football Foundation - Football Stars Award Ceremony Trailer",
    "client": "Turkish Football Foundation & Luys Media",
    "year": 2023,
    "shortDescription": "Luys Magazin - cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri Luys Magazin - Türkiye Futbol Vakfı Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Resim Seçici Bora Selimoğlu Kamera Artun Sağbazar, Enes Aktel Editor Bora Selimoğlu\n\nTürkiye Futbol Federasyonu Sosyal Yardım ve Dayanışma Vakfı\n\nTürkiye Futbol Federasyonu Sosyal Yardım ve Dayanışma Vakfı (TFF SYDV), futbolun gücünü toplumsal yardımla buluşturuyor. Profesyonel futbolculara yaşam sigortası, bakım ve yaşam merkezleri, sağlık hizmetleri ve maddi destek gibi sosyal yardımlar sunan vakıf, vize ve transfer işlemlerinden oluşturulan fonlarla yardıma muhtaç futbolcu ve ailelerine destek sağlıyor. Türkiye Futbol Vakfı, futbolun yanı sıra toplumsal sorumlulukları da önemseyen bir kuruluş olarak ön plana çıkıyor.\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Luys Magazin -"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Enes Aktel"
      }
    ],
    "coverImage": "/project-covers/turkiye-futbol-vakfi-odul-toreni-trailer.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=Xgv9O9SD3Og",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/turkiye-futbol-vakfi-odul-toreni-trailer/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Luys Magazin - cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Luys Magazin - that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "gazturman-gayan-50th-anniversary-event-trailer",
    "slug": "gazturman-gayan-50th-anniversary-event-trailer",
    "title": "Gazturman Gayan 50th Anniversary Gala - Official Event Film",
    "client": "Gazturman Gayan & Luys Media",
    "year": 2023,
    "shortDescription": "Luys Magazin - Gazturman Gayan cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri Luys Magazin - Gazturman Gayan Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Reji Bora Selimoğlu Assistant Director/Operator Bora Selimoğlu Kamera Artun Sağbazar, Harutyun Arto Davulciyan, Enes Aktel, Baret Tercan Kurgu Bora Selimoğlu Editor Bora Selimoğlu\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Luys Magazin -"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Reji",
        "name": "Bora Selimoğlu"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Harutyun Arto Davulciyan, Enes Aktel, Baret Tercan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/gazturman-gayan-50th-anniversary-event-trailer.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=JEQAGR4mWKI",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/gazturman-gayan-50th-anniversary-event-trailer/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 3 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Luys Magazin - Gazturman Gayan cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Luys Magazin - Gazturman Gayan that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "eskisehir-anadolu-universitesi-esitlik-kazansin-trailer",
    "slug": "eskisehir-anadolu-universitesi-esitlik-kazansin-trailer",
    "title": "Eskisehir Anadolu University - Equality Wins Event Trailer",
    "client": "Anadolu University",
    "year": 2023,
    "shortDescription": "Dynamic promotional trailer celebrating the 'Equality Wins' initiative at Anadolu University, focusing on gender equality and inclusivity.",
    "fullDescription": "Client: Anadolu University | Production & Post: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nCinematography: Harutyun Arto Davulciyan, Artun Sağbazar\nLead Editor: Bora Selimoğlu\n\nAnadolu University: Equality Wins\n\nA cinematic event trailer capturing the energy, community engagement, and message of inclusivity at Anadolu University.",
    "categories": [
      "Etkinlik Filmleri",
      "Tanıtım Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri",
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Anadolu Üniversitesi"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/eskisehir-anadolu-universitesi-esitlik-kazansin-trailer.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=8_uWcG_4ZjQ",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/eskisehir-anadolu-universitesi-esitlik-kazansin-trailer/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Promoted awareness on equality and student leadership with high-energy visuals across university channels.",
    "challenge": "Translating institutional values into an engaging, contemporary visual narrative for university students.",
    "insight": "High-tempo pacing and authentic on-campus interactions maximize student engagement.",
    "solution": "Produced with dynamic gimbal camera moves, upbeat musical synchronization, and vibrant color grading.",
    "productionCraft": "4K Capture, 3-axis gimbal camera systems, rhythmic editing, and sound design.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "4K Event Production"
  },
  {
    "id": "fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi",
    "slug": "fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi",
    "title": "KUTES - Crafting the Transformation of Molten Iron with Cinematic Storytelling",
    "client": "Kutes Döküm",
    "year": 2025,
    "shortDescription": "A cinematic industrial commercial that elevates brand prestige and engineering excellence across global B2B manufacturing markets.",
    "fullDescription": "Client: KUTES | Agency: Federation Agency | Production: WE'24 Agency & FUGS | Post-Production: WE'24 Agency\n\nDirector: Harutyun Arto Davulciyan\nDirector of Photography: Furkan Uyan\nCreative Director: Ali Algür\nArt Director: Aren Arda Kaya\nExecutive Producers: Ali Algür, Furkan Uyan\nAssistant Direction: Andre Dinkiyan, Kami Balmumcu\nDrone Pilot: Furkan Uyan\nEditors: Bora Selimoğlu, Harutyun Arto Davulciyan\nColorists: Harutyun Arto Davulciyan, Furkan Uyan\n\nKUTES: Crafting the Transformation of Molten Iron with Cinematic Storytelling\n\nThis high-end industrial film merges foundry manufacturing technology with cinematic aesthetics to establish corporate prestige across international B2B markets. Captured with high-speed 4K 60FPS and 4K 120FPS cinema cameras, 4K professional drone aerials, macro lenses highlighting molten iron at 1500°C, and dedicated industrial foley sound design, the production delivers a captivating journey through the heart of the foundry.",
    "categories": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri",
      "Reklam Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri",
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "KUTES"
      },
      {
        "role": "Ajans",
        "name": "Federation Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency & FUGS"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Furkan Uyan"
      },
      {
        "role": "Creative Director",
        "name": "Ali Algür"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Ali Algür, Furkan Uyan"
      },
      {
        "role": "Reji",
        "name": "Andre Dinkiyan, Kami Balmumcu"
      },
      {
        "role": "Drone Pilotu",
        "name": "Furkan Uyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu, Harutyun Arto Davulciyan"
      },
      {
        "role": "Renk",
        "name": "Harutyun Arto Davulciyan, Furkan Uyan"
      }
    ],
    "coverImage": "/project-covers/fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=g1FVLDljoZ8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "A cinematic industrial commercial that elevates brand prestige and engineering excellence across global B2B manufacturing markets.",
    "challenge": "Overcoming generic heavy-industry tropes to create a cutting-edge corporate film highlighting green energy, foundry automation, and global export power.",
    "insight": "Global B2B buyers choose partners based on visual proof of discipline, safety, and modern engineering. The glow of molten metal at 1500°C conveys immense brand strength.",
    "solution": "We deployed 4K 60FPS and 4K 120FPS high-speed cinema camera setups, 4K professional drone aerials, macro lenses for molten iron textures, and dynamic sound design.",
    "productionCraft": "Cinematography in 4K 120FPS and 4K 60FPS, 4K Drone aerial cinematography, multilingual dubbing in Turkish, English & German, cine prime lenses, and industrial color grading.",
    "metrics": [
      {
        "label": "Shooting Format",
        "value": "4K 60FPS & 120FPS"
      },
      {
        "label": "Aerial Cinematography",
        "value": "4K Drone Footage"
      },
      {
        "label": "Multilingual Dubbing",
        "value": "TR, EN, DE Dubbing"
      },
      {
        "label": "Location",
        "value": "Tekirdağ / Çorlu"
      },
      {
        "label": "Co-Production",
        "value": "WE24 & FUGS"
      }
    ],
    "deliverables": [
      "4K Cinematic Master Film (3:30)",
      "4K Drone & Industrial Master Cuts",
      "Turkish, English & German Dubbing & Subtitles",
      "LinkedIn B2B Video Edits"
    ],
    "productionStandard": "4K 60FPS & 120FPS Sinematik Çekim"
  },
  {
    "id": "fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency",
    "slug": "fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency",
    "title": "Sapro - Türkiye'nin Islak Mendil Devine Global İhracat Vizyonu",
    "client": "Sapro Temizlik Ürünleri",
    "year": 2024,
    "shortDescription": "Multilingual corporate brand film highlighting Sapro's European market leadership, 45,000 m² automated facility, and exports across 6 continents.",
    "fullDescription": "Client: Sapro | Agency: Contactplus+ | Production & Post-Production: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nExecutive Producer: Fatih Uzgören\nCamera: Artun Sağbazar, Baret Borucuyan, Edvin Büyükloker\nLead Editor: Bora Selimoğlu\n\nSapro: Global Export Vision for Europe's Wet Wipe Pioneer\n\nShowcasing Sapro’s European manufacturing leadership and export reach to over 65 countries across 6 continents, this corporate film captures high-speed automated robotics, microbiology cleanrooms, and 24/7 global logistics with a sleek cinematic rhythm and full English voiceover.",
    "categories": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Sapro"
      },
      {
        "role": "Ajans",
        "name": "Contactplus+"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Fatih Uzgören"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar, Baret Borucuyan, Edvin Büyükloker"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=nTrh1F-iw_Q",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Multilingual corporate brand film highlighting Sapro's European market leadership, 45,000 m² automated facility, and exports across 6 continents.",
    "challenge": "Producing a pristine corporate film that meets strict European and US retailer hygiene and compliance audit standards.",
    "insight": "For global private-label giants, uninterrupted production capacity and uncompromising cleanroom standards are paramount. The film delivers indisputable visual evidence.",
    "solution": "Full-frame cinema cameras captured automated robotics, microbiology labs, and logistics cycles, packaged with professional English voiceovers for international B2B clients.",
    "productionCraft": "Sony FX3 & FX6 Full Frame cinema cameras, 2 languages (TR, EN) voiceover, precision gimbal rigs, and cleanroom protective gear.",
    "metrics": [
      {
        "label": "Camera Systems",
        "value": "Sony FX3 & FX6 Full Frame"
      },
      {
        "label": "Language Options",
        "value": "2 Languages (TR, EN)"
      },
      {
        "label": "Facility Area",
        "value": "45,000 m² Facility"
      },
      {
        "label": "Export Footprint",
        "value": "65+ Countries on 6 Continents"
      }
    ],
    "deliverables": [
      "4K Global Brand Film Master",
      "Short Social & Expo Teasers",
      "R&D and Sustainability Featurettes"
    ],
    "productionStandard": "Sony FX3 & FX6 Full Frame"
  },
  {
    "id": "teka-estetik-web-sitesi",
    "slug": "teka-estetik-web-sitesi",
    "title": "Teka Estetik - Web Sitesi",
    "client": "Teka Estetik",
    "year": 2024,
    "shortDescription": "Teka Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "1970 yılında kurulan Teka A.Ş., kuruluşundan bu yana sağlık hizmetlerinde en kaliteli ürün ve hizmetleri sunmayı hedefleyen bir şirkettir. Türkiye'de ilaç, tıbbi cihaz, OTC ve dermokozmetik ürünlerde faaliyet gösteren Teka A.Ş., dünya çapındaki şirketlerle (Cantabria Labs, VIVACY) iş birliği yaparak Türk sağlık sektöründe önemli bir rol üstlenmiştir. Teka Estetik'in kurumsal ve ürün vitrini web platformu WE24 Agency tarafından uçtan uca tasarlanıp hayata geçirilmiştir.",
    "categories": [
      "Web Siteleri",
      "Yazılım"
    ],
    "services": [
      "Web Siteleri",
      "Yazılım"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Teka Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      }
    ],
    "coverImage": "/project-covers/teka-estetik-web-sitesi.webp",
    "gallery": [
      "/project-covers/teka-estetik-web-sitesi-g1.webp"
    ],
    "videoUrl": "",
    "videoProvider": null,
    "originalSourceUrl": "https://we24.com.tr/project/teka-estetik-web-sitesi/",
    "featured": true,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Teka Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Teka Estetik that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "kristal-piksel-2025-canli-yayin",
    "slug": "kristal-piksel-2025-canli-yayin",
    "title": "Kristal Piksel 2025 - Live Broadcast & Stage Directing",
    "client": "TOGED",
    "year": 2025,
    "shortDescription": "End-to-end 360° production for Kristal Piksel 2025: brand identity, logo design, stage LED screen visuals, stage-light-sound direction, and multi-camera live broadcast.",
    "fullDescription": "Client: TOGED | Agency: WE’24 Agency | Production: 24Creative & WE'24 Agency | Post-Production: WE’24 Agency & 24Creative\n\nEvent & Broadcast Director: Harutyun Arto Davulciyan\nArt Director & LED Screen Design: Aren Arda Kaya\nStage, Lighting, Sound & LED Directing: Harutyun Arto Davulciyan & WE24 Team\nBrand Identity, Logo & Graphic Design: Aren Arda Kaya & WE24 Design Team\nProducer: Tuğbek Ölek | Executive Producer & Live Stream: Baret Tercan\nGimbal Operators: Mert Ünlü, Heros Agopyan | Cameramen: Sarkis Dolaş, Kami Balmumcu\nEditors: Bora Selimoğlu, Baret Tercan | Still Photographer: Kami Balmumcu | Social Media: Efi Kayıkçiyan\n\nKristal Piksel 2025: Turkey’s Video Game Awards\n\nCelebrating its 12th year as Turkey's premier video game awards ceremony, Kristal Piksel 2025 was directed and produced end-to-end through a partnership between WE24 Agency and 24Creative. The entire brand identity, logo design, dynamic stage LED animations, stage timing, lighting-sound choreography, and multi-camera live stream direction were executed by Harutyun Arto Davulciyan and our creative team.",
    "categories": [
      "Canlı Yayın",
      "Etkinlik Filmleri"
    ],
    "services": [
      "Canlı Yayın",
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TOGED"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "24Creative & WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency & 24Creative"
      },
      {
        "role": "Etkinlik & Canlı Yayın Yönetmeni",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni & LED Ekran Tasarımı",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Sahne, Işık, Ses & LED Ekran Yönetimi",
        "name": "Harutyun Arto Davulciyan & WE24 Ekibi"
      },
      {
        "role": "Kurumsal Kimlik, Logo ve Grafik Tasarım",
        "name": "Aren Arda Kaya & WE24 Tasarım Ekibi"
      },
      {
        "role": "Yapımcı",
        "name": "Tuğbek Ölek"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Baret Tercan"
      },
      {
        "role": "Canlı Yayın",
        "name": "Baret Tercan"
      },
      {
        "role": "Gimbal Operatörü",
        "name": "Mert Ünlü, Heros Agopyan"
      },
      {
        "role": "Kameraman",
        "name": "Sarkis Dolaş, Kami Balmumcu"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu, Baret Tercan"
      },
      {
        "role": "Fotoğrafçı",
        "name": "Kami Balmumcu"
      },
      {
        "role": "Sosyal Medya",
        "name": "Efi Kayıkçiyan"
      }
    ],
    "coverImage": "/project-covers/kristal-piksel-2025-canli-yayin.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=1254bUGsKA8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/kristal-piksel-2025-canli-yayin/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Full 360° execution of Kristal Piksel 2025 Video Game Awards: branding, logo design, dynamic LED screen animations, and multi-camera live broadcast directing.",
    "challenge": "Orchestrating live multi-camera feeds, synchronized LED visuals, and physical stage choreography with zero latency for high-profile gaming industry audiences.",
    "insight": "High-stakes gaming award ceremonies demand high-energy visuals, instantaneous switcher cues, and immersive stage ambiance to maintain audience immersion.",
    "solution": "From initial identity and logo design to dynamic motion graphics, sound engineering, and live switcher direction, our team delivered a seamless broadcast experience.",
    "productionCraft": "Multi-camera live broadcast switcher, real-time stage LED motion design, synchronized concert-grade lighting & sound engineering, and DaVinci Resolve live color tuning.",
    "metrics": [
      {
        "label": "Broadcast & Stage",
        "value": "360° Stage, Light, Sound, LED"
      },
      {
        "label": "Visual Identity",
        "value": "Logo, Branding & LED Design"
      },
      {
        "label": "Co-Production",
        "value": "24Creative & WE24"
      },
      {
        "label": "Stream Format",
        "value": "Multi-Cam Live Broadcast"
      }
    ],
    "deliverables": [
      "360° Stage, Light, Sound & LED Directing",
      "Multi-Camera Live Broadcast Stream Master",
      "Event Brand Identity, Logo & Graphic Design Suite",
      "Custom Stage LED Animations & Video Packages",
      "Social Media Video Cuts & Highlights Edit"
    ]
  },
  {
    "id": "dicle-tekstil-fabrika-tanitim-filmi-we24-agency-kurumsal-film",
    "slug": "dicle-tekstil-fabrika-tanitim-filmi-we24-agency-kurumsal-film",
    "title": "Dicle Tekstil - Integrated Spinning & Weaving Mill Brand Film",
    "client": "Dicle Tekstil",
    "year": 2025,
    "shortDescription": "Dicle Tekstil cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri Dicle Tekstil Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Sanat Yönetmeni Aren Arda Kaya Yürütücü Yapımcı Baret Tercan Reji Baret Borucuyan, Kami Balmumcu Drone Harutyun Arto Davulciyan Kurgu Bora Selimoğlu, Harutyun Arto Davulciyan Renk Harutyun Arto Davulciyan\n\n1975’te kurulan Dicle Tekstil, yıllar içinde Hindistan, Endonezya, Çin, Vietnam, Nepal, Tayland ve Pakistan’ı kapsayan geniş bir tedarik ağı geliştirdi. Yuvarlak örme, dokuma, triko ve dar dokuma üreticilerinin iplik ihtiyaçlarını stoktan karşılayarak sektörde konumlandı. Kaliteyi yönetmek ve sürdürülebilir üretimi kendi kontrolü altında yürütmek amacıyla Kütahya’da bir iplik fabrikası yatırımına gitti. Temmuz 2022’den beri faaliyette olan tesis, yüksek otomasyon seviyesine sahip olup 60.000 m² arazi üzerinde 45.000 m² kapalı alanda hizmet veriyor. Tesiste iplik çekim, elyaf boyama, büküm ve punta bölümleri bulunuyor; güneş enerji sistemi, ısı geri kazanımı ve atık su arıtma altyapılarıyla, sürdürülebilir elyaflardan üretim yaklaşımını destekliyor.\n\nWE’24 Agency olarak, Dicle Tekstil’in 1975’ten bugüne uzanan tedarik kabiliyetini ve Kütahya’daki entegre iplik üretim altyapısını modern, endüstriyel bir görsel dille anlattık. Filmde; stoktan hızlı tedarik yaklaşımı, yüksek otomasyonlu üretim hatları, elyaf boyama-büküm-punta süreçleri ve sürdürülebilirlik odaklı sistemler (GES, ısı geri kazanımı, atık su arıtma) öne çıkarıldı. Amaç, markanın kalite, hız ve sorumluluk ekseninde şekillenen üretim anlayışını yalın bir anlatım ve gerçek üretim görüntüleriyle portföyde net biçimde konumlandırmaktı.\n\nDijital İletişim Ajansı",
    "categories": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Dicle Tekstil"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Baret Tercan"
      },
      {
        "role": "Reji",
        "name": "Baret Borucuyan, Kami Balmumcu"
      },
      {
        "role": "Drone",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu, Harutyun Arto Davulciyan"
      },
      {
        "role": "Renk",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/dicle-tekstil-fabrika-tanitim-filmi-we24-agency-kurumsal-film.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=lOI0fPH4TD4",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/dicle-tekstil-fabrika-tanitim-filmi-we24-agency-kurumsal-film/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Dicle Tekstil cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Dicle Tekstil that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "okm-seminer-istanbul-wow-hotel",
    "slug": "okm-seminer-istanbul-wow-hotel",
    "title": "OKM Medical Technology Seminar - Istanbul WOW Hotel",
    "client": "OKM",
    "year": 2023,
    "shortDescription": "OKM cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri OKM Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nGimbal Operatör/Kamera Artun Sağbazar Uygulayıcı Yapımcı Larissa Davulciyan Kurgu Bora Selimoğlu\n\nOKM: Alman Dedektör Markası\n\nDedektör endüstrisinde benzersiz bir fikirden trend belirleyiciye: Bir zamanlar ev garajında hobi olarak başlayan OKM, bugün dünya çapında başarılı bir şirkettir.\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "OKM"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/okm-seminer-istanbul-wow-hotel.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=g2wiJx5ltIU",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/okm-seminer-istanbul-wow-hotel/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "OKM cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for OKM that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "hayatta-kalma-savasi-nepal-trt-belgesel",
    "slug": "hayatta-kalma-savasi-nepal-trt-belgesel",
    "title": "Hayatta Kalma Savaşı: Nepal - TRT Belgesel İçin Zorlu Coğrafyalarda Sinematik Hikaye Anlatımı",
    "client": "TRT Belgesel",
    "year": 2023,
    "shortDescription": "TRT Belgesel cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Hafifletilmiş yüksek kaliteli sinema kamera kitleri ve bağımsız ses kayıt sistemleri ile 3000+ metre irtifada 14 günlük zorlu bir keşif ve prodüksiyon süreci yürütüldü.",
    "categories": [
      "Belgeseller"
    ],
    "services": [
      "Belgeseller"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TRT Belgesel"
      },
      {
        "role": "Ajans",
        "name": "Yemen Film Yapım I YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Yapımcı",
        "name": "Uluç Yemen Aslan"
      },
      {
        "role": "Yönetmen",
        "name": "Abdurrahman Houssain"
      }
    ],
    "coverImage": "/project-covers/hayatta-kalma-savasi-nepal-trt-belgesel.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=3q_a18ykzjE",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/hayatta-kalma-savasi-nepal-trt-belgesel/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "TRT Belgesel cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for TRT Belgesel that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "arma-kontrol-reklam-filmi",
    "slug": "arma-kontrol-reklam-filmi",
    "title": "Arma Kontrol - Yüksek Güvenlik Bariyer Sistemleri Reklam Filmi",
    "client": "Arma Kontrol",
    "year": 2024,
    "shortDescription": "Arma Kontrol cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Aksiyon filmi ritminde kurgulanan sahneler, gece ışıklandırması ve çarpışma anlarının detaylı ağır çekimleri ile markanın \"tavizsiz güvenlik\" iddiası görselleştirildi.",
    "categories": [
      "Reklam Filmleri"
    ],
    "services": [
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Arma Kontrol"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/arma-kontrol-reklam-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=ieAguHreNys",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/arma-kontrol-reklam-filmi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Arma Kontrol cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Arma Kontrol that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "6K RAW & 4K 50FPS cinematic master capture, 4K RAW 240fps high-speed camera for crash tests, Ronin 2 gimbal, and cinematic sound design.",
    "metrics": [
      {
        "label": "Shooting Format",
        "value": "6K RAW & 4K 50FPS"
      },
      {
        "label": "High-Speed Testing",
        "value": "4K RAW 240fps"
      },
      {
        "label": "Export Market",
        "value": "55+ Countries"
      },
      {
        "label": "Location",
        "value": "Crash Test Field & Plant"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "6K RAW ve 4K 50FPS"
  },
  {
    "id": "cagla-gursoy-ile-tarzim-cepte-turkcell-bip",
    "slug": "cagla-gursoy-ile-tarzim-cepte-turkcell-bip",
    "title": "Çağla Gürsoy ile Tarzım Cepte - Turkcell BiP",
    "client": "4Play & Turkcell BiP",
    "year": 2023,
    "shortDescription": "4Play & Turkcell BiP cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri 4Play & Turkcell BiP Ajans CYemen Film Yapım I YFY Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Artun Sağbazar Kurgu Bora Selimoğlu\n\nTurkcell BiP: Yerli Teknolojilerle Geliştirilen Güvenli İletişim Platformu\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "4Play & Turkcell BiP"
      },
      {
        "role": "Ajans",
        "name": "Yemen Film Yapım I YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/cagla-gursoy-ile-tarzim-cepte-turkcell-bip.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=ZQdnzvvmpcw",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/cagla-gursoy-ile-tarzim-cepte-turkcell-bip/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 2 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "4Play & Turkcell BiP cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for 4Play & Turkcell BiP that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "seger-korna-montaji-i-nasil-yapilir-serisi",
    "slug": "seger-korna-montaji-i-nasil-yapilir-serisi",
    "title": "Seger - Korna Montajı I \"Nasıl Yapılır?\" Serisi",
    "client": "SEGER",
    "year": 2024,
    "shortDescription": "SEGER cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri SEGER Ajans YFY Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Uluç Yemen Aslan Görüntü Yönetmeni Harutyun Arto Davulciyan Kamera Asistanı Artun Sağbazar Ses Teknisyeni Yener Yalçın Kurgu Bora Selimoğlu\n\nSeger: Adımızı Bilmezsiniz Ama Sesimizi Bilirsiniz\n\nWE24 Agency olarak Seger’in 10 farklı korna serisi için hazırladığımız ‘Nasıl Yapılır’ videoları, kullanıcıların ve yetkili bayilerin kolay ve doğru montaj yapabilmeleri için adım adım rehberlik sunmaktadır. Bu videolar, Seger’in ürün kalitesi ve müşteri odaklı yaklaşımını destekleyerek, pratik ve anlaşılır bir şekilde montaj süreçlerini anlatmaktadır.\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "SEGER"
      },
      {
        "role": "Ajans",
        "name": "YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Uluç Yemen Aslan"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera Asistanı",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Ses Teknisyeni",
        "name": "Yener Yalçın"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/seger-korna-montaji-i-nasil-yapilir-serisi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=fy1mPRC-fcg",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/seger-korna-montaji-i-nasil-yapilir-serisi/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "SEGER cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for SEGER that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "seger-fuar-tanitim-filmi-2",
    "slug": "seger-fuar-tanitim-filmi-2",
    "title": "Seger - Fuar Tanıtım Filmi",
    "client": "SEGER",
    "year": 2024,
    "shortDescription": "SEGER cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri SEGER Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nSeslendirme Harutyun Arto Davulciyan Kurgu Bora Selimoğlu\n\nSeger: Adımızı Bilmezsiniz Ama Sesimizi Bilirsiniz\n\nWE24 Agency olarak Seger için hazırladığımız fuar tanıtım filmi, firmanın global başarısını, otomotiv sektöründeki yenilikçi üretim gücünü ve toplumsal cinsiyet eşitliğine verdiği desteği vurgulamaktadır. Seger, yüksek kaliteli kornaları ve aydınlatma çözümleriyle Türkiye’yi dünyada gururla temsil etmektedir.\n\nDijital İletişim Ajansı",
    "categories": [
      "Tanıtım Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "SEGER"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/seger-fuar-tanitim-filmi-2.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=gX5vHthB8vU",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/seger-fuar-tanitim-filmi-2/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "SEGER cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for SEGER that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi",
    "slug": "tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi",
    "title": "3B FAB - 3D Printing & Additive Manufacturing Brand Film",
    "client": "3B FAB",
    "year": 2025,
    "shortDescription": "3B FAB cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri 3B FAB Ajans FUGS Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Görüntü Yönetmeni Furkan Uyan Sanat Yönetmeni Aren Arda Kaya Yürütücü Yapımcı Furkan Uyan Kamera Andre Dinkiyan, Harutyun Arto Davulciyan Kurgu Bora Selimoğlu, Harutyun Arto Davulciyan Renk Harutyun Arto Davulciyan\n\n3B FAB 2013’te kurulan NovaFab, üretime yönelik 3D yazıcılar ve fotopolimer reçineler geliştirip üretmektedir. NovaFab’ın ekosistemi; CAD/CAM tasarım, profesyonel 3D yazıcılar ve “Design Market” üzerinden binlerce baskıya hazır ürünü kapsar. Miami, Amsterdam ve Dubai’nin de aralarında bulunduğu 7 lokasyonda ofisleri bulunan şirketin yazıcıları ve malzemeleri, bayileri aracılığıyla 60’tan fazla ülkede binlerce profesyonel tarafından kullanılmaktadır. 3BFAB, mücevher odaklı çözümlerini Novafab, dişçilik çözümlerini Dentafab ve fotopolimer reçinelerini PowerResins markalarıyla konumlandırır.\n\nWE’24 Agency olarak, 3B FAB’in (NovaFab) dijital üretim ekosistemini; CAD/CAM tasarım, profesyonel 3D yazıcılar ve fotopolimer reçine çözümleri ekseninde, modern ve teknolojik bir anlatımla görünür kılmayı hedefledik. Yaratıcı ve planlama süreci FUGS tarafından yönetilen projede; markanın mücevher ve dişçilik profesyonellerine sunduğu hız, kolaylık ve maliyet avantajlarını, süreçlerden kesitler ve ürün odaklı görüntülerle bir araya getirdik. Küresel ölçekteki erişimi ve kullanıcı geri bildirimlerine dayalı ürün geliştirme yaklaşımını öne çıkaran bu film, 3B FAB’in üretimde güvenilir ve bütünleşik bir çözüm sunma iddiasını net ve tutarlı bir görsel dil ile ifade eder.\n\nDijital İletişim Ajansı",
    "categories": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri",
      "Reklam Filmleri"
    ],
    "services": [
      "Tanıtım Filmleri",
      "Fabrika Filmleri",
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "3B FAB"
      },
      {
        "role": "Ajans",
        "name": "FUGS"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Furkan Uyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Furkan Uyan"
      },
      {
        "role": "Kamera",
        "name": "Andre Dinkiyan, Harutyun Arto Davulciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu, Harutyun Arto Davulciyan"
      },
      {
        "role": "Renk",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi.webp",
    "gallery": [],
    "videoUrl": "https://youtu.be/kaI5uuNQvJI",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi/",
    "featured": false,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "3B FAB cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for 3B FAB that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "1351",
    "slug": "1351",
    "title": "Alfa Solar - Solar PV Commercial & Record-Breaking IPO Campaign",
    "client": "Alfa Solar",
    "year": 2023,
    "shortDescription": "Cinematic national commercial for Alfa Solar's IPO campaign; featuring an original musical score composed in WE24 Studios and driving record-breaking investor turnout.",
    "fullDescription": "Client: Alfa Solar | Agency: Levent Kuğu | Production & Post-Production: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nOriginal Score: Avedis Özdemir (Composed & Recorded at WE24 Studio)\nExecutive Producer: Levent Kuğu\nAssistant Direction: Andre Dinkiyan, Larissa Davulciyan\nLead Editor: Bora Selimoğlu | Camera Assistant: Umut Yıldırım\n\nAlfa Solar: Turkey’s Leading Solar Photovoltaic Manufacturer\n\nDesigned to inspire investor confidence and reinforce brand authority throughout Alfa Solar's public offering (IPO), this commercial aired extensively across national TV networks and digital channels. The original musical score was exclusively composed by WE24 musician Avedis Özdemir and recorded with live instrumentation in our studio. Delivered in full broadcast and multi-format digital masters, the campaign spearheaded historical record-breaking investor demand and market success.",
    "categories": [
      "Reklam Filmleri"
    ],
    "services": [
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Alfa Solar"
      },
      {
        "role": "Ajans",
        "name": "Levent Kuğu"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Özgün Müzik",
        "name": "Avedis Özdemir (WE24 Studio)"
      },
      {
        "role": "Yürütücü Yapımcı",
        "name": "Levent Kuğu"
      },
      {
        "role": "Reji",
        "name": "Andre Dinkiyan, Larissa Davulciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      },
      {
        "role": "Kamera Asistanı",
        "name": "Umut Yıldırım"
      }
    ],
    "coverImage": "/project-covers/1351.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=BOE_Of1YRrg",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/?p=1351",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Nationwide TV and digital commercial campaign driving historic record-breaking participation and investor demand during Alfa Solar's IPO.",
    "challenge": "Translating clean solar energy technology and industrial manufacturing scale into a cinematic narrative that commands investor trust and public prestige.",
    "insight": "In financial and IPO campaigns, high-end cinematography paired with an exclusive custom musical score elevates emotional conviction and investor buy-in.",
    "solution": "End-to-end production directed by Harutyun Arto Davulciyan and Aren Arda Kaya, elevated by Avedis Özdemir's studio-recorded original score.",
    "productionCraft": "4K Cinema camera rigs, dedicated studio score recording & audio mastering, DaVinci Resolve color science, and multi-format TV & digital distribution masters.",
    "metrics": [
      {
        "label": "IPO Result",
        "value": "Historic Record Turnout"
      },
      {
        "label": "Distribution",
        "value": "National TV & Digital"
      },
      {
        "label": "Original Music",
        "value": "Avedis Özdemir (WE24)"
      },
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      }
    ],
    "deliverables": [
      "National TV Broadcast Master Copies",
      "Digital & Social Media Video Cuts (16:9, 9:16)",
      "Exclusive Original Musical Score & Audio Mix",
      "High-Resolution Press & Media Stills"
    ]
  },
  {
    "id": "heliocare-yaza-merhaba-partisi-teaser",
    "slug": "heliocare-yaza-merhaba-partisi-teaser",
    "title": "Heliocare Yaza Merhaba Partisi - Teaser",
    "client": "TEKA Estetik - Heliocare",
    "year": 2023,
    "shortDescription": "TEKA Estetik - Heliocare cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri TEKA Estetik - Heliocare Ajans WE’24 Agency Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Uygulayıcı Yapımcı Larissa Davulciyan Kamera Enes Aktel Fotoğraf Kami Garbis Balmumciyan Kurgu Bora Selimoğlu\n\nTEKA Estetik: Lider Dermokozmetik Ürünler Distribütorü\n\nTürkiye’nin önde gelen sağlık markalarından biri olan TEKA, ilaç, tıbbi cihaz, OTC ve dermokozmetik ürünlerinde kalite ve hizmet odaklı bir hizmet sunmaktadır. Oftalmoloji, dermatoloji, medikal estetik ve jinekoloji alanlarında faaliyet gösteren TEKA, dünya şirketleriyle iş birlikleri yaparak sağlık sektöründe önemli bir konumda yer almaktadır. HELIOCARE ve VIVACY gibi markaları bünyesinde barındıran TEKA, yenilikçi ve etkili anti-aging çözümleriyle sağlık profesyonelleri ve hastalar için hedeflerine odaklanmaktadır.\n\nDijital İletişim Ajansı",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "TEKA Estetik - Heliocare"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Enes Aktel"
      },
      {
        "role": "Fotoğraf",
        "name": "Kami Garbis Balmumciyan"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/heliocare-yaza-merhaba-partisi-teaser.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=S5_0X2sAbIE",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/heliocare-yaza-merhaba-partisi-teaser/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "TEKA Estetik - Heliocare cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for TEKA Estetik - Heliocare that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "vw-kristal-elma-official-aftermovie",
    "slug": "vw-kristal-elma-official-aftermovie",
    "title": "Volkswagen - Kristal Elma Creativity Festival Official Aftermovie",
    "client": "Volkswagen Turkey",
    "year": 2023,
    "shortDescription": "High-energy official aftermovie capturing Volkswagen's brand presence and interactive experiences at the Kristal Elma Festival.",
    "fullDescription": "Client: Volkswagen Turkey | Production & Post: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nLead Editor: Bora Selimoğlu\n\nVolkswagen at Kristal Elma Creativity Festival\n\nCapturing the pulse, excitement, and brand activations of Volkswagen during Turkey's premier advertising and creativity festival with fast-paced cinematic editing.",
    "categories": [
      "Etkinlik Filmleri"
    ],
    "services": [
      "Etkinlik Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Volkswagen Türkiye"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/vw-kristal-elma-official-aftermovie.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=8kObhCXcp38",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/vw-kristal-elma-official-aftermovie/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Highlighted Volkswagen's innovative brand engagement among advertising industry leaders.",
    "challenge": "Condensing two days of high-intensity creative festival activities into a cohesive, fast-paced aftermovie.",
    "insight": "Synchronizing kinetic camera movement with punchy electronic beats maximizes festival excitement.",
    "solution": "Utilized multi-camera gimbal coverage, rapid-fire pacing, and high-contrast color grading.",
    "productionCraft": "4K Stabilized capture, beat-synced editing, ambient audio foley.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "4K Festival Production"
  },
  {
    "id": "nasil-dustum-bu-derde-guney-marlen",
    "slug": "nasil-dustum-bu-derde-guney-marlen",
    "title": "Guney Marlen - Nasil Dustum Bu Derde Music Video",
    "client": "Guney Marlen",
    "year": 2023,
    "shortDescription": "Cinematic music video for songwriter Guney Marlen's indie-pop single 'Nasil Dustum Bu Derde'.",
    "fullDescription": "Artist: Guney Marlen | Production & Post: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nLead Editor: Bora Selimoğlu\n\nGuney Marlen: Nasil Dustum Bu Derde\n\nA visually rich music video framing urban melancholy with cinematic lighting and expressive storytelling.",
    "categories": [
      "Video Klipler"
    ],
    "services": [
      "Video Klipler"
    ],
    "credits": [
      {
        "role": "Sanatçı",
        "name": "Güney Marlen"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/nasil-dustum-bu-derde-guney-marlen.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=VjunJpLv8ZM",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/nasil-dustum-bu-derde-guney-marlen/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 3 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Deepened the artist's visual brand across Turkish independent music audiences.",
    "challenge": "Creating an authentic visual counterpart to the poetic storytelling of the song.",
    "insight": "Cinematic street lighting and moody color grading foster strong emotional resonance.",
    "solution": "Filmed in 4K with prime lenses, utilizing atmospheric city lights and expressive close-ups.",
    "productionCraft": "4K Low-light cinematography, customized color grade, synchronized narrative edit.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "Cinematic 4K"
  },
  {
    "id": "altinmarka-tarif-videolari",
    "slug": "altinmarka-tarif-videolari",
    "title": "Altınmarka - Dünyanın Seçkin Çikolatası İçin Gastronomik Video İçerik Serisi",
    "client": "Altınmarka",
    "year": 2024,
    "shortDescription": "Altınmarka cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Özel stüdyo ortamında kontrollü ısı ve ışık koşullarında makro lensler, yüksek hızlı (high-speed slow motion) kameralar ve uzman food stylist işbirliği ile 12 özel tarif filmi üretildi.",
    "categories": [
      "YouTube Projeleri",
      "Sosyal Medya"
    ],
    "services": [
      "YouTube Projeleri",
      "Sosyal Medya"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Altınmarka"
      },
      {
        "role": "Ajans",
        "name": "FUGS - Furkan Uyan Görsel Sanatlar"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Görüntü Yönetmeni",
        "name": "Furkan Uyan"
      },
      {
        "role": "Kurgu",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/altinmarka-tarif-videolari.webp",
    "gallery": [
      "/project-covers/altinmarka-tarif-videolari-g1.webp",
      "/project-covers/altinmarka-tarif-videolari-g2.webp"
    ],
    "videoUrl": "https://www.youtube.com/watch?v=dQuJGBmcqnM",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/altinmarka-tarif-videolari/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Altınmarka cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Altınmarka that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "Sony FX3 + 100mm Macro Cinema Lens, 120fps High-Speed Slow-Motion and bespoke gastronomic color grading.",
    "metrics": [
      {
        "label": "Video Series",
        "value": "12 Masterclass Episodes"
      },
      {
        "label": "Frame Rate",
        "value": "120fps High-Speed Slow Motion"
      },
      {
        "label": "Shooting Standard",
        "value": "4K Macro Cinema"
      },
      {
        "label": "Deliverables",
        "value": "16:9 4K & 9:16 Reels"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "4K 120FPS Slow-Motion"
  },
  {
    "id": "yemen-turkude-sakli-olan-efsane",
    "slug": "yemen-turkude-sakli-olan-efsane",
    "title": "Yemen: The Legend Hidden in the Folk Song - Historical Documentary",
    "client": "Luys Media & TRT",
    "year": 2023,
    "shortDescription": "Epic historical documentary exploring the untold human stories and cultural legacy behind the timeless Yemen folk anthem.",
    "fullDescription": "Client: Luys Media | Production & Post: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nLead Editor: Bora Selimoğlu\n\nYemen: The Legend Hidden in the Folk Song\n\nA deep historical documentary blending archival footage and cinematic re-enactments to trace the emotional origins of the legendary Yemen ballad.",
    "categories": [
      "Belgeseller"
    ],
    "services": [
      "Belgeseller"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Luys Media"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/yemen-turkude-sakli-olan-efsane.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=i0-vOobbd-c",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/yemen-turkude-sakli-olan-efsane/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Preserved critical oral history and cultural heritage with high broadcast standards.",
    "challenge": "Bringing century-old military memories and folklore to life using archival restoration and dramatic pacing.",
    "insight": "Authentic period foley, evocative voiceover, and meticulous restoration bridge past and present for documentary audiences.",
    "solution": "Combined high-resolution digital archival restoration with modern sound design and cinematic pacing.",
    "productionCraft": "Historical archival restoration, 4K broadcast mastering, authentic acoustic soundtrack design.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "4K Documentary Production"
  },
  {
    "id": "guney-marlen-eda-baba-seni-unutmak",
    "slug": "guney-marlen-eda-baba-seni-unutmak",
    "title": "Guney Marlen & Eda Baba - Seni Unutmak Music Video",
    "client": "Guney Marlen & Eda Baba",
    "year": 2023,
    "shortDescription": "Evocative music video for the emotional duet 'Seni Unutmak' by Guney Marlen and Eda Baba.",
    "fullDescription": "Artists: Guney Marlen & Eda Baba | Production & Post: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nLead Editor: Bora Selimoğlu\n\nGuney Marlen & Eda Baba: Seni Unutmak\n\nBlending intimate close-up cinematography with warm cinematic tones to reflect the depth of this duet.",
    "categories": [
      "Video Klipler"
    ],
    "services": [
      "Video Klipler"
    ],
    "credits": [
      {
        "role": "Sanatçılar",
        "name": "Güney Marlen & Eda Baba"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/guney-marlen-eda-baba-seni-unutmak.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=aF8vjvYkrb8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/guney-marlen-eda-baba-seni-unutmak/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 5 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Elevated the collaboration across streaming music platforms with millions of organic impressions.",
    "challenge": "Visually complementing the vocal chemistry of two independent artists in an intimate setting.",
    "insight": "Warm vintage color palettes and delicate close-ups enhance viewer intimacy for ballad collaborations.",
    "solution": "Shot in 4K with vintage cine glass, emphasizing soft shadows, rich skin tones, and gentle movement.",
    "productionCraft": "4K Cinema capture, vintage prime aesthetics, DaVinci Resolve color grading.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "Cinematic 4K"
  },
  {
    "id": "endocare-renewal-serisi-reklam-filmi",
    "slug": "endocare-renewal-serisi-reklam-filmi",
    "title": "Endocare Renewal Serisi - Reklam Filmi",
    "client": "Teka Estetik",
    "year": 2024,
    "shortDescription": "Teka Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri Teka Estetik Ajans WE’24 Agency Tasarım WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Sanat Yönetmeni Aren Arda Kaya Kurgu Harutyun Arto Davulciyan\n\nWE24 Agency olarak Teka Estetik’in İstanbul, Ankara ve Antalya’da gerçekleştirdiği ‘Endocare Renewal Serisi’ lansman etkinliklerinin aftermovie’sini hazırladık. Bu video, etkinliklerin atmosferini, katılımcıların deneyimlerini ve markanın öne çıkan anlarını etkileyici bir şekilde yansıtarak unutulmaz bir lansman serisi ortaya koyuyor.\n\nDijital İletişim Ajansı",
    "categories": [
      "Reklam Filmleri"
    ],
    "services": [
      "Reklam Filmleri"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Teka Estetik"
      },
      {
        "role": "Ajans",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Harutyun Arto Davulciyan"
      }
    ],
    "coverImage": "/project-covers/endocare-renewal-serisi-reklam-filmi.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=WH7HP4hh8h8",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/endocare-renewal-serisi-reklam-filmi/",
    "featured": true,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 1 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Teka Estetik cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for Teka Estetik that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  },
  {
    "id": "garbis-zakaryan-belgeseli-luys-media",
    "slug": "garbis-zakaryan-belgeseli-luys-media",
    "title": "Garbis Zakaryan - Turkey's First National Boxing Champion Documentary",
    "client": "Luys Media",
    "year": 2023,
    "shortDescription": "Award-winning biographical documentary celebrating Turkey's first professional national boxing champion, Garbis Zakaryan; inducted into TRT Archives and broadcast on TRT Belgesel.",
    "fullDescription": "Client: Luys Media | Agency: WE24 Agency | Production & Post-Production: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nScreenwriter: Belinda Kuran\nLead Editor: Bora Selimoğlu (WE24 Agency)\nSocial Media: Larissa Davulciyan\nProducer: Harutyun Kuran | Production Coordinator: Ayk Gülezyan, Meri Kuran\nCamera Assistant: Baret Borucuyan, Baret Tercan, Lukas Şarklı, Edgar İgityan\n\nGarbis Zakaryan: Turkey’s First Professional National Boxer\n\nBecoming Turkey’s first professional national boxer at the age of 24, Garbis Zakaryan claimed the Middle East Boxing Championship in 1964 following his Istanbul and Turkish national titles. Throughout a legendary 22-year athletic career, he competed in over 200 amateur bouts and nearly 100 professional matches (including 43 international bouts).\n\nRepresenting Turkey across Germany, France, Argentina, Lebanon, and Egypt, Zakaryan retired from the ring in 1966. This historical documentary focuses on his early boxing journey amidst the hardships of World War II and his inspiring rise to the championship. The production was preserved in the permanent TRT Archive, continues to air on TRT Belgesel, and received a prestigious special screening at the International TRT Documentary Awards.",
    "categories": [
      "Belgeseller"
    ],
    "services": [
      "Belgeseller"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "Luys Media"
      },
      {
        "role": "Ajans",
        "name": "WE24 Agency"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Senarist",
        "name": "Belinda Kuran"
      },
      {
        "role": "Kurgu Yönetmeni",
        "name": "Bora Selimoğlu"
      },
      {
        "role": "Sosyal Medya",
        "name": "Larissa Davulciyan"
      },
      {
        "role": "Yapımcı",
        "name": "Harutyun Kuran"
      },
      {
        "role": "Yapım Koordinatörü",
        "name": "Ayk Gülezyan, Meri Kuran"
      },
      {
        "role": "Kamera Asistanı",
        "name": "Baret Borucuyan, Baret Tercan, Lukas Şarklı, Edgar İgityan"
      }
    ],
    "coverImage": "/project-covers/garbis-zakaryan-belgeseli-luys-media.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=Kmpj6kYdCWw",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/garbis-zakaryan-belgeseli-luys-media/",
    "featured": true,
    "confidence": "high",
    "contentWarnings": [],
    "strategicImpact": "Historic biographical documentary inducted into TRT Archives, regularly airing on TRT Belgesel, and honored with a special screening at the International TRT Documentary Awards.",
    "challenge": "Restoring historical archival footage, vintage photographs, and oral histories into a cohesive, cinematic 4K narrative.",
    "insight": "Documenting national athletic legends demands dramatic pacing, respectful archival restoration, and intimate storytelling that resonates across generations.",
    "solution": "End-to-end documentary production led by Harutyun Arto Davulciyan and Aren Arda Kaya, written by Belinda Kuran and edited by Bora Selimoğlu.",
    "productionCraft": "Exclusively filmed in 16:9 aspect ratio in 4K 25FPS 4:2:2 color sampling, archival restoration, DaVinci Resolve color grading, and historical interview editing.",
    "metrics": [
      {
        "label": "Broadcast & Archive",
        "value": "TRT Archive & TRT Belgesel"
      },
      {
        "label": "Honors",
        "value": "International TRT Awards"
      },
      {
        "label": "Shooting Format",
        "value": "4K 25FPS 4:2:2"
      },
      {
        "label": "Aspect Ratio",
        "value": "Exclusively 16:9"
      },
      {
        "label": "Legacy",
        "value": "First Pro Boxer of Turkey"
      }
    ],
    "deliverables": [
      "4K 25FPS 16:9 Master Documentary Film",
      "TRT Belgesel & TV Broadcast Master",
      "Digital & Social Media Promotional Clips",
      "Restored Archival Photography"
    ],
    "productionStandard": "4K 25FPS 4:2:2 (16:9)"
  },
  {
    "id": "gelmiyorsun-ezginin-gunlugu-eda-baba",
    "slug": "gelmiyorsun-ezginin-gunlugu-eda-baba",
    "title": "Eda Baba - Gelmiyorsun (Ezginin Gunlugu Tribute) Music Video",
    "client": "Eda Baba & Ezginin Gunlugu",
    "year": 2023,
    "shortDescription": "Cinematic music video for Eda Baba's heartfelt rendition of Ezginin Gunlugu's classic ballad 'Gelmiyorsun'.",
    "fullDescription": "Artist: Eda Baba & Ezginin Gunlugu | Production & Post: WE’24 Agency\n\nDirector: Harutyun Arto Davulciyan\nArt Director: Aren Arda Kaya\nLead Editor: Bora Selimoğlu\n\nGelmiyorsun - Ezginin Gunlugu 40th Anniversary Album\n\nA poetic music video honoring 40 years of musical legacy with refined visual aesthetics and soulful performance capture.",
    "categories": [
      "Video Klipler"
    ],
    "services": [
      "Video Klipler"
    ],
    "credits": [
      {
        "role": "Sanatçı",
        "name": "Eda Baba"
      },
      {
        "role": "Müzik",
        "name": "Ezginin Günlüğü"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Sanat Yönetmeni",
        "name": "Aren Arda Kaya"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/gelmiyorsun-ezginin-gunlugu-eda-baba.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=QtsTO4lFGIc",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/gelmiyorsun-ezginin-gunlugu-eda-baba/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 3 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "Featured prominently in Ezginin Gunlugu's 40th anniversary tribute album with high critical acclaim.",
    "challenge": "Reinterpreting a beloved 40-year classic ballad with respectful and fresh cinematography.",
    "insight": "Minimalist interior framing and gentle natural light enhance the listener's focus on the emotional lyrics.",
    "solution": "Shot in 4K with prime lenses, focusing on natural light, subtle shadows, and intimate framing.",
    "productionCraft": "4K 25FPS 4:2:2 capture, DaVinci Resolve color science, minimalist visual pacing.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ],
    "productionStandard": "4K Cinema Format"
  },
  {
    "id": "sergen-ile-10-numara-muhabbet-turkcell-bip",
    "slug": "sergen-ile-10-numara-muhabbet-turkcell-bip",
    "title": "Sergen ile 10 Numara Muhabbet - Turkcell BiP",
    "client": "4Play & Turkcell BiP",
    "year": 2023,
    "shortDescription": "4Play & Turkcell BiP cinematic production designed to elevate brand authority and drive audience engagement.",
    "fullDescription": "Müşteri 4Play & Turkcell BiP Ajans CYemen Film Yapım I YFY Prodüksiyon WE’24 Agency Post Prodüksiyon WE’24 Agency\n\nYönetmen Harutyun Arto Davulciyan Kamera Artun Sağbazar Kurgu Bora Selimoğlu\n\nTurkcell BiP: Yerli Teknolojilerle Geliştirilen Güvenli İletişim Platformu\n\nDijital İletişim Ajansı",
    "categories": [
      "Video Prodüksiyon"
    ],
    "services": [
      "Video Prodüksiyon"
    ],
    "credits": [
      {
        "role": "Müşteri",
        "name": "4Play & Turkcell BiP"
      },
      {
        "role": "Ajans",
        "name": "Yemen Film Yapım I YFY"
      },
      {
        "role": "Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Post Prodüksiyon",
        "name": "WE'24 Agency"
      },
      {
        "role": "Yönetmen",
        "name": "Harutyun Arto Davulciyan"
      },
      {
        "role": "Kamera",
        "name": "Artun Sağbazar"
      },
      {
        "role": "Kurgu",
        "name": "Bora Selimoğlu"
      }
    ],
    "coverImage": "/project-covers/sergen-ile-10-numara-muhabbet-turkcell-bip.webp",
    "gallery": [],
    "videoUrl": "https://www.youtube.com/watch?v=4eACV2hwOJA",
    "videoProvider": "youtube",
    "originalSourceUrl": "https://we24.com.tr/project/sergen-ile-10-numara-muhabbet-turkcell-bip/",
    "featured": false,
    "confidence": "medium",
    "contentWarnings": [
      "Removed 2 contaminated duplicate paragraphs."
    ],
    "strategicImpact": "4Play & Turkcell BiP cinematic production designed to elevate brand authority and drive audience engagement.",
    "challenge": "Creating a distinctive visual narrative for 4Play & Turkcell BiP that stands out in competitive digital and broadcast channels.",
    "insight": "In modern visual communication, immediate aesthetic engagement and emotional storytelling determine viewer retention.",
    "solution": "WE24 Agency delivered an end-to-end production with high-end cinema equipment, dedicated art direction, and meticulous post-production.",
    "productionCraft": "4K/6K cinema cameras, professional stage lighting, DaVinci Resolve color science, and spatial audio mastering.",
    "metrics": [
      {
        "label": "Visual Format",
        "value": "4K Ultra HD"
      },
      {
        "label": "Production Tier",
        "value": "Cinema Standard"
      },
      {
        "label": "Deliverable Formats",
        "value": "16:9 & 9:16 Social"
      }
    ],
    "deliverables": [
      "4K Cinema Master",
      "Social Media Video Cuts",
      "High-Res Production Stills"
    ]
  }
];
